import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { StatBox, StatCardComponent } from '../../components/stat-card/stat-card.component';
import { StepStats, StepTypeDistribution } from '../../models/dashboard.model';

interface DistributionBar {
  labelKey: string;
  count: number;
  width: string;
  colorVar: string;
}

const STEP_TYPE_COLOR_VARS: Readonly<Record<string, string>> = {
  STEP: '--to-cyan-dot',
  PRECONDITION: '--to-blue-dot',
  POSTCONDITION: '--to-warn-dot',
};

const KNOWN_STEP_TYPES = new Set(Object.keys(STEP_TYPE_COLOR_VARS));

@Component({
  selector: 'app-testschritte-stats-card',
  imports: [TranslatePipe, StatCardComponent],
  templateUrl: './testschritte-stats.component.html',
  styleUrl: './testschritte-stats.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestschritteStatsCardComponent {
  schritte = input.required<StepStats>();

  protected readonly stats = computed<StatBox[]>(() => {
    const s = this.schritte();
    return [
      { labelKey: 'liveDashboard.qualitaet.schritte.gesamt', value: s.gesamt, colorVar: '--to-text-strong' },
      {
        labelKey: 'liveDashboard.qualitaet.schritte.automatisiert',
        value: s.automatisiert,
        colorVar: '--to-purple-fg',
      },
      { labelKey: 'liveDashboard.qualitaet.schritte.verwaist', value: s.verwaist, colorVar: '--to-amber-deep' },
    ];
  });

  protected readonly bars = computed<DistributionBar[]>(() => {
    const total = this.schritte().gesamt || 1;
    return this.schritte().verteilung.map((entry) => this.toBar(entry, total));
  });

  private toBar(entry: StepTypeDistribution, total: number): DistributionBar {
    const colorVar = STEP_TYPE_COLOR_VARS[entry.typ];
    return {
      labelKey: KNOWN_STEP_TYPES.has(entry.typ) ? `liveDashboard.qualitaet.stepType.${entry.typ}` : entry.typ,
      count: entry.anzahl,
      width: `${(entry.anzahl / total) * 100}%`,
      colorVar: colorVar ?? '--to-slate-dot',
    };
  }
}
